import { lib } from '@giscube/geoportal'
import ca from './ca'
import enUS from './en-us'
import es from './es'

export default new lib.Options({
  'ca': ca,
  'en-us': enUS,
  'es': es
})
